import { useAuthorization } from 'components/Authorization';
import { useCallback, useRef, useState } from 'react';
import Cache from 'utils/Cache';

const getKey = (userId?: number) => {
  return `PhraseDisplayMode/${userId}`;
};

export type Mode = 'onlyOriginal' | 'onlyFianl' | 'all';

export function usePhraseDisplayMode(sideMode?: boolean) {
  const { payload } = useAuthorization<Oversea.Token.Payload>();

  const ref = useRef({
    cache: new Cache(localStorage, getKey(payload?.id)),
  });

  const [mode, setMode] = useState(() => {
    const mode = ref.current.cache.get<Mode>();
    if (mode) {
      return mode;
    }
    if (sideMode) {
      return 'all';
    }
    const oldCache = new Cache(localStorage, `PhraseTranslateOpened/${payload?.id}`).get<boolean>();
    return oldCache ? 'all' : 'onlyFianl';
  });

  const onModeChange = useCallback((mode: Mode) => {
    ref.current.cache.set(mode);
    setMode(mode);
  }, []);

  return {
    mode,
    onModeChange,
  };
}
